// Centralized content file for Combo Box Restaurant
import logoImage from "./assets/Combo-box.png";
import heroBg1 from "./assets/hero-kitchen-1.png";
import heroBg2 from "./assets/hero-kitchen-2.png";
import heroBg3 from "./assets/hero-kitchen-3.png";

// Blog cover images
import blogCover1 from "./assets/box/KalyaanaVirunthu-NawabiCater.jpeg";
import blogCover2 from "./assets/about-img-2-1.jpg";
import blogCover3 from "./assets/open-kitchen-QYEP83V.jpg";

// Import Box Images

// Combo Meal Images
import img_ChickenBiryaniComboServes12ComboFor12PersonNonVegCBjpg from "./assets/box/ChickenBiryaniCombo-Serves12-ComboFor12PersonNon-VegCB.jpg";
import img_FourItemComboNonVegServes12ComboFor12PersonNonVegCBjpg from "./assets/box/FourItemComboNon-Veg-Serves12-ComboFor12PersonNon-VegCB.jpg";
import img_FourItemComboVegServes12ComboFor12PersonVegCBjpg from "./assets/box/FourItemComboVeg-Serves12-ComboFor12PersonVegCB.jpg";
import img_ThreeItemComboNonVegServes12ComboFor12PersonNonVegCBjpg from "./assets/box/ThreeItemComboNon-Veg-Serves12-ComboFor12PersonNon-VegCB.jpg";
import img_ThreeItemComboVegServes12ComboFor12PersonVegCBjpg from "./assets/box/ThreeItemComboVeg-Serves12-ComboFor12PersonVegCB.jpg";
import img_TwoItemComboNonVegServes12ComboFor12PersonNonVegCBjpg from "./assets/box/TwoItemComboNon-Veg-Serves12-ComboFor12PersonNon-VegCB.jpg";
import img_TwoItemComboVegServes12ComboFor12PersonVegCBjpg from "./assets/box/TwoItemComboVeg-Serves12-ComboFor12PersonVegCB.jpg";

// Parotta Combo Images
import img_2pcsParottaEggKeemaChicken653pcspng from "./assets/box/2pcsParottaEggKeemaChicken-653pc.jpeg";
import img_2pcsParottaVegChettinaduVegSukkapng from "./assets/box/2pcsParottaVegChettinaduVegSukk.jpeg";
import img_2pcsParottaChickenChettinadu from "./assets/box/2pcsParottaChickenChettinadu.jpeg";

// Chapati Combo Images
import img_2pcsChappatiChickenMasalaTandooriLeg1pcspng from "./assets/box/2pcsChappatiChickenMasalaTandooriLeg-1pc.jpeg";
import img_2pcsChappatiEggMasalaChicken653pcspng from "./assets/box/2pcsChappatiEggMasalaChicken-653pc.jpeg";
import img_2pcsChappatiEggKeemaMasala2png from "./assets/box/2pcsChappatiVegSukkaPlainChettinadGravy.jpeg";
import img_2pcsChappatiVegSukkaPlainChettinadGravy from "./assets/box/2pcsChappatiVegSukkaPlainChettinadGravy.jpeg";

// Veg Fried Rice Combo Images
import img_VegFriedRiceVegSukka from "./assets/box/VegFriedRiceVegSukka.jpeg";
import img_VegFriedRiceVegLollypop3Pcs from "./assets/box/VegFriedRiceVegLollypop3Pcs.jpeg";

// Dosa Combo Images
import img_2pcsDosaEggMasalapng from "./assets/box/2pcsDosaEggMasal.jpeg";
import img_2pcsEggDosaChetinaduPlainGravypng from "./assets/box/2pcsEggDosaChetinaduPlainGrav.jpeg";
import img_2pcsDosaChickenCurrypng from "./assets/box/2pcsDosaChickenCurr.jpeg";
import img_2pcsDosaKadaiVegVegLollypop3pcs from "./assets/box/2pcsDosaKadaiVegVegLollypop3pcs.jpeg";

// Tandoori Chicken Combo Images
import img_TandooriChicken1pcsTandooriRoti2pcsEggMasalapng from "./assets/box/TandooriChicken-1pcsTandooriRoti-2pcsEggMasal.jpeg";
import img_TandooriChicken1pcsPulk4pcsMixVegCurrypng from "./assets/box/TandooriChicken-1pcsPulk-4pcsMixVegCurr.jpeg";
import img_TandooriChicken1pcsEggFriedRice from "./assets/box/TandooriChicken-1pcsEggFriedRice.jpeg";
import img_TandooriChickenHalfEggFriedRicepng from "./assets/box/TandooriChickenHalfEggFriedRic.jpeg";

// Chicken Kebab Combo Images
import img_3pcsChickenKebabDhalRicepng from "./assets/box/3pcsChickenKebabDhalRic.jpeg";
import img_3pcsChickenKebabCurdRicepng from "./assets/box/3pcsChickenKebabCurdRic.jpeg";
import img_3pcsChickenKebabEggFriedRicepng from "./assets/box/3pcsChickenKebabEggFriedRic.jpeg";

// Barbequeen Chicken Combo Images
import img_AlFaham1pcsPulka4pcsEggChettinadupng from "./assets/box/Al-Faham-1pcsPulka-4pcsEggChettinad.jpeg";
import img_AlFahamHalfPulka2pcsCucumberSaladpng from "./assets/box/Al-FahamHalfPulka-2pcsCucumberSala.jpeg";
import img_AlFaham1pcsDhalRicepng from "./assets/box/Al-Faham-1pcsDhalRic.jpeg";

// Sea Food Combo Images
import img_CrispyFriedFishEggFriedRice from "./assets/box/CrispyFriedFishEggFriedRice.jpeg";
import img_ButterflyPrawns4pcsEggFriedRice from "./assets/box/ButterflyPrawns-4pcsEggFriedRice.jpeg";

// Beverage Images
import img_FreshLimesod from "./assets/box/FreshLimesod.jpeg";
import img_FreshLimesoda from "./assets/box/FreshLimesoda.jpeg";
import img_MintLimeMojito from "./assets/box/MintLimeMojito.jpeg";
import img_GreenAppleMojito from "./assets/box/GreenAppleMojito.jpeg";
import img_VirginBlueMojito from "./assets/box/VirginBlueMojito.jpg";
import img_BananaDelight from "./assets/box/BananaDelight.jpg";
import img_IcedCaremalCoffee from "./assets/box/IcedCaremalCoffee.jpg";
import img_OreaoCandy from "./assets/box/OreaoCandy.jpg";
import img_MintLimeSoda from "./assets/box/MintLimeSoda.jpg";
import img_MintLimeJuice from "./assets/box/MintLimeJuice.jpg";
import img_VennilaMilkshake from "./assets/box/VennilaMilkshake.jpg";
import img_StrawberryMilkShake from "./assets/box/StrawberryMilkShake.jpg";
import img_ChocolateMilkShake from "./assets/box/ChocolateMilkShake.jpg";
import img_MangoMilkshake from "./assets/box/MangoMilkshake.jpg";
import img_BlackCurrentMilkShake from "./assets/box/BlackCurrentMilkShake.jpg";
import img_ButterscotchMilkShake from "./assets/box/ButterscotchMilkShake.jpg";
import img_WaterMelonJuice from "./assets/box/WaterMelonJuice.jpg";
import img_OrangeJuice from "./assets/box/OrangeJuice.jpg";
import img_SathukudiJuice from "./assets/box/SathukudiJuice.jpg";
import img_PinappleJuice from "./assets/box/PinappleJuice.jpg";
import img_AppleJuice from "./assets/box/AppleJuice.jpg";
import img_MuskmelonJuice from "./assets/box/MuskmelonJuice.jpg";
import img_PomogranateJuice from "./assets/box/PomogranateJuice.jpg";
import img_TwinBerry from "./assets/box/TwinBerry.jpg";

// Dessert Images
import img_GulabJamun2pcs from "./assets/box/GulabJamun2pcs.jpeg";
import img_BreadHalwa100gms from "./assets/box/BreadHalwa100gms.jpg";
import img_Brownie60gms from "./assets/box/Brownie60gms.jpg";

// Gallery / Blog Images
import img_KalyaanaVirunthuNawabiCaterspng from "./assets/box/KalyaanaVirunthu-NawabiCater.jpeg";

// Biryani Images
import img_classicChickenBiryani from "./assets/box/classic_chicken_biryan.jpeg";
import img_classicBiryaniCombo from "./assets/box/classic_biryani_comb.jpeg";
import img_eggBiryani from "./assets/box/egg_biryan.jpeg";
import img_muttonBiryani from "./assets/box/mutton_biryan.jpeg";
import img_muttonBiryaniCombo from "./assets/box/mutton_biryani_comb.jpeg";
import img_prawnBiryani from "./assets/box/prawn_biryan.jpeg";
import img_seafoodCombo from "./assets/box/seafood_comb.jpeg";
import img_specialBiryaniCombo from "./assets/box/special_biryani_comb.jpeg";

// Rice Box Images
import img_chickenFriedRiceBox from "./assets/box/chicken_fried_rice_bo.jpeg";
import img_chickenRiceBox from "./assets/box/chicken_rice_bo.jpeg";
import img_doubleComboBox from "./assets/box/double_combo_bo.jpeg";
import img_eggComboBox from "./assets/box/egg_combo_bo.jpeg";
import img_muttonRiceBox from "./assets/box/mutton_rice_bo.jpeg";
import img_prawnRiceBox from "./assets/box/prawn_rice_bo.jpeg";

export const SITE_CONTENT = {
  global: {
    logoText: "Combo Box",
    logoImage: logoImage,
    topBar: {
      phone: "+91 91502 99336",
      email: "nonveecombobox@gmail.com",
      socials: [
        { icon: "facebook", href: "#" },
        {
          icon: "youtube",
          href: "https://youtube.com/@combobox-s3w?si=-cSKTuS7a2PSNfiB",
        },
        {
          icon: "instagram",
          href: "https://www.instagram.com/comboboxnonvee?igsh=MWI5Z3g1bXFrazQ2Yg==",
        },
      ],
    },
    navLinks: [
      { label: "Menu", to: "/#menu" },
      { label: "Why Us", to: "/#why" },
      { label: "About", to: "/#about" },
      { label: "Blog", to: "/#blog" },
      { label: "Contact", to: "/#contact" },
    ],
    orderLinks: [
      {
        label: "Order on Swiggy 🛵",
        href: "https://www.swiggy.com/city/salem/combo-box-main-rd-salem-bus-stand-rest883293",
        platform: "swiggy",
      },
      {
        label: "Order on Zomato 🍴",
        href: "https://www.zomato.com/salem/combo-box-alagapuram-pudur",
        platform: "zomato",
      },
    ],
    orderLocations: {
      Salem: {
        zomato: "https://www.zomato.com/salem/combo-box-alagapuram-pudur",
        swiggy:
          "https://www.swiggy.com/city/salem/combo-box-main-rd-salem-bus-stand-rest883293",
      },
      Coimbatore: {
        zomato: "https://www.zomato.com/coimbatore/combo-box-1-saibaba-colony",
        swiggy:
          "https://www.swiggy.com/city/coimbatore/combo-box-venkitapuram-saibaba-colony-rest1151753",
      },
      Erode: {
        zomato:
          "https://www.zomato.com/erode/combo-box-edayankattuvalasu/order",
        swiggy:
          "https://www.swiggy.com/city/erode/combo-box-perundurai-rd-central-erode-rest875889",
      },
    },
    footer: {
      brandDesc:
        "Combo Box is a 100% Halal certified non-veg quick-service restaurant brand under combobox, Tamil Nadu. We serve complete non-veg combo meals at honest prices across Salem, Coimbatore, and Erode.",
      socials: [
        { icon: "facebook", href: "#" },
        {
          icon: "youtube",
          href: "https://youtube.com/@combobox-s3w?si=-cSKTuS7a2PSNfiB",
        },
        {
          icon: "instagram",
          href: "https://www.instagram.com/comboboxnonvee?igsh=MWI5Z3g1bXFrazQ2Yg==",
        },
      ],
      cols: [
        {
          title: "Quick Links",
          links: [
            { label: "Our Menu", to: "#menu" },
            { label: "Order Online", to: "#order" },
            { label: "Why Us", to: "#why" },
            { label: "About", to: "#about" },
            { label: "Blog", to: "#blog" },
          ],
        },
        {
          title: "Order From",
          links: [
            {
              label: "Zomato",
              to: "https://www.zomato.com/salem/combo-box-alagapuram-pudur/order",
            },
            { label: "Swiggy", to: "https://www.swiggy.com" },
            { label: "Call Directly", to: "tel:+919150299336" },
          ],
        },
        {
          title: "Our Locations",
          links: [
            { label: "Salem — Alagapuram Pudur", to: "/order?city=Salem" },
            { label: "Coimbatore", to: "/order?city=Coimbatore" },
            { label: "Erode", to: "/order?city=Erode" },
            { label: "combobox.in", to: "https://combobox.in" },
          ],
        },
      ],
      copy: "© 2025 Combo Box. All rights reserved.",
      parentBrand: {
        label: "A combobox Brand",
        href: "https://combobox.in",
      },
    },
  },
  sections: {
    hero: {
      slides: [
        {
          image: heroBg1,
          tagline: "Tamil Nadu's #1 Combo Brand",
          title: "EVERY BITE IN A BOX.",
          subtitle:
            "Tamil Nadu's most loved 100% Halal non-veg combo meals, packed into one perfect box. Seeraga Samba Biryani combos, rice boxes, chicken specials — value meals that never compromise on taste.",
          button: {
            label: "Order Now 🛵",
            href: "/order",
          },
        },
        {
          image: heroBg2,
          tagline: "100% Halal Certified",
          title: "ROYAL SEERAGA SAMBA BIRYANI",
          subtitle:
            "Authentic Seeraga Samba Biryani · Rice Boxes · Chicken Specials",
          button: { label: "See Our Menu", href: "/#menu" },
        },
        {
          image: heroBg3,
          tagline: "Fresh Every Day",
          title: "BOLD TAMIL NADU FLAVOURS",
          subtitle:
            "100% Halal · 100% Non-Veg · Daily Fresh Ingredients · Fast Delivery",
          button: { label: "Explore Today's Menu", href: "/#menu" },
        },
      ],
    },

    stats: [
      { number: "10+", label: "Combo Varieties" },
      { number: "4.0★", label: "Zomato Rating" },
      { number: "100%", label: "Halal Certified" },
      { number: "3", label: "Locations — TN" },
    ],

    menu: {
      eyebrow: "Our Menu",
      title: "PICK YOUR COMBO",
      subtitle:
        "Every combo is packed with the right portions, the right price, and the right taste — only at Combo Box. All our meats are 100% Halal certified.",
      note: "⚠️ Prices and items are indicative. Check Zomato for live menu & latest pricing.",
      tabs: [
        {
          id: "combo-meals",
          label: "Combo Meals",
        },
        {
          id: "beverages",
          label: "Beverages",
        },
        {
          id: "delightful-dessert",
          label: "Delightful Dessert",
        },
        {
          id: "parotta-combo",
          label: "Parotta Combo",
        },
        {
          id: "chapati-combo",
          label: "Chapati Combo",
        },
        {
          id: "veg-fried-rice-combo",
          label: "Veg Fried Rice Combo",
        },
        {
          id: "dosa-combo",
          label: "Dosa Combo",
        },
        {
          id: "tandoori-chicken-combo",
          label: "Tandoori Chicken Combo",
        },
        {
          id: "chicken-kebab-combo",
          label: "Chicken Kebab Combo",
        },
        {
          id: "barbequeen-chicken-combo",
          label: "Barbequeen Chicken Combo",
        },
        {
          id: "sea-food-combo",
          label: "Sea Food Combo",
        },
      ],
      panels: {
        "combo-meals": [
          {
            emoji: "🥗",
            image: img_TwoItemComboVegServes12ComboFor12PersonVegCBjpg,
            badge: "Veg",
            name: "Two Item Combo (Veg) - (Serves 1)",
            desc: "Combo For 1 Person ( Veg )[CB]",
            tag: "Veg | Halal",
            price: "259",
          },
          {
            emoji: "🍗",
            image: img_ChickenBiryaniComboServes12ComboFor12PersonNonVegCBjpg,
            badge: "Non-Veg",
            name: "Chicken Biryani Combo - (Serves 1)",
            desc: "Combo For 1 Person ( Non-Veg )[CB]",
            tag: "Non-Veg | Halal",
            price: "275",
          },
          {
            emoji: "🍗",
            image: img_TwoItemComboNonVegServes12ComboFor12PersonNonVegCBjpg,
            badge: "Non-Veg",
            name: "Two Item Combo (Non-Veg) - (Serves 1)",
            desc: "Combo For 1 Person ( Non-Veg )[CB]",
            tag: "Non-Veg | Halal",
            price: "269",
          },
          {
            emoji: "🥗",
            image: img_ThreeItemComboVegServes12ComboFor12PersonVegCBjpg,
            badge: "Veg",
            name: "Three Item Combo (Veg) - (Serves 1)",
            desc: "Combo For 1 Person ( Veg )[CB]",
            tag: "Veg | Halal",
            price: "279",
          },
          {
            emoji: "🍗",
            image: img_ThreeItemComboNonVegServes12ComboFor12PersonNonVegCBjpg,
            badge: "Non-Veg",
            name: "Three Item Combo (Non-Veg) - (Serves 1)",
            desc: "Combo For 1 Person ( Non-Veg )[CB]",
            tag: "Non-Veg | Halal",
            price: "279",
          },
          {
            emoji: "🥗",
            image: img_FourItemComboVegServes12ComboFor12PersonVegCBjpg,
            badge: "Veg",
            name: "Four Item Combo (Veg) - (Serves 1)",
            desc: "Combo For 1 Person ( Veg )[CB]",
            tag: "Veg | Halal",
            price: "369",
          },
          {
            emoji: "🍗",
            image: img_FourItemComboNonVegServes12ComboFor12PersonNonVegCBjpg,
            badge: "Non-Veg",
            name: "Four Item Combo (Non-Veg) - (Serves 1)",
            desc: "Combo For 1 Person ( Non-Veg )[CB]",
            tag: "Non-Veg | Halal",
            price: "389",
          },
          {
            emoji: "🥗",
            image: img_TwoItemComboVegServes12ComboFor12PersonVegCBjpg,
            badge: "Veg",
            name: "Two Item Combo (Veg) - (Serves 2)",
            desc: "Combo For 2 People ( Veg )[CB]",
            tag: "Veg | Halal",
            price: "449",
          },
          {
            emoji: "🍗",
            image: img_ChickenBiryaniComboServes12ComboFor12PersonNonVegCBjpg,
            badge: "Non-Veg",
            name: "Chicken Biryani Combo - (Serves 2)",
            desc: "Combo For 2 People ( Non-Veg )[CB]",
            tag: "Non-Veg | Halal",
            price: "479",
          },
          {
            emoji: "🍗",
            image: img_TwoItemComboNonVegServes12ComboFor12PersonNonVegCBjpg,
            badge: "Non-Veg",
            name: "Two Item Combo (Non-Veg) - (Serves 2)",
            desc: "Combo For 2 People ( Non-Veg )[CB]",
            tag: "Non-Veg | Halal",
            price: "489",
          },
          {
            emoji: "🥗",
            image: img_ThreeItemComboVegServes12ComboFor12PersonVegCBjpg,
            badge: "Veg",
            name: "Three Item Combo (Veg) - (Serves 2)",
            desc: "Combo For 2 People ( Veg )[CB]",
            tag: "Veg | Halal",
            price: "509",
          },
          {
            emoji: "🍗",
            image: img_ThreeItemComboNonVegServes12ComboFor12PersonNonVegCBjpg,
            badge: "Non-Veg",
            name: "Three Item Combo (Non-Veg) - (Serves 2)",
            desc: "Combo For 2 People ( Non-Veg )[CB]",
            tag: "Non-Veg | Halal",
            price: "519",
          },
          {
            emoji: "🥗",
            image: img_FourItemComboVegServes12ComboFor12PersonVegCBjpg,
            badge: "Veg",
            name: "Four Item Combo (Veg) - (Serves 2)",
            desc: "Combo For 2 People ( Veg )[CB]",
            tag: "Veg | Halal",
            price: "659",
          },
          {
            emoji: "🍗",
            image: img_FourItemComboNonVegServes12ComboFor12PersonNonVegCBjpg,
            badge: "Non-Veg",
            name: "Four Item Combo (Non-Veg) - (Serves 2)",
            desc: "Combo For 2 People ( Non-Veg )[CB]",
            tag: "Non-Veg | Halal",
            price: "699",
          },
          {
            emoji: "🥗",
            image: img_FourItemComboVegServes12ComboFor12PersonVegCBjpg,
            badge: "Veg",
            name: "Four Item Combo (Veg) - (Serves 4)",
            desc: "Combo For 4 People[CB]",
            tag: "Veg | Halal",
            price: "1249",
          },
          {
            emoji: "🍗",
            image: img_FourItemComboNonVegServes12ComboFor12PersonNonVegCBjpg,
            badge: "Non-Veg",
            name: "Four Item Combo (Non-Veg) - (Serves 4)",
            desc: "Combo For 4 People[CB]",
            tag: "Non-Veg | Halal",
            price: "1349",
          },
        ],
        beverages: [
          {
            emoji: "🥗",
            image: img_FreshLimesod,
            badge: "Veg",
            name: "Fresh Lime Juice",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "79",
          },
          {
            emoji: "🥗",
            image: img_FreshLimesoda,
            badge: "Veg",
            name: "Fresh Lime Soda",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "89",
          },
          {
            emoji: "🥗",
            image: img_MintLimeMojito,
            badge: "Veg",
            name: "Mint Lime Mojito",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "149",
          },
          {
            emoji: "🥗",
            image: img_GreenAppleMojito,
            badge: "Veg",
            name: "Green Apple Mojito",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "149",
          },
          {
            emoji: "🥗",
            image: img_VirginBlueMojito,
            badge: "Veg",
            name: "Virgin Blue Mojito",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "149",
          },
          {
            emoji: "🥗",
            image: img_BananaDelight,
            badge: "Veg",
            name: "Banana Delite",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "189",
          },
          {
            emoji: "🥗",
            image: img_IcedCaremalCoffee,
            badge: "Veg",
            name: "Iced Caremal Coffee",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "189",
          },
          {
            emoji: "🥗",
            image: img_OreaoCandy,
            badge: "Veg",
            name: "Oreo Candy",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "189",
          },
          {
            emoji: "🥗",
            image: img_MintLimeSoda,
            badge: "Veg",
            name: "Mint Lime Soda",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "129",
          },
          {
            emoji: "🥗",
            image: img_MintLimeJuice,
            badge: "Veg",
            name: "Mint Lime Juice",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "119",
          },
          {
            emoji: "🥗",
            image: img_VennilaMilkshake,
            badge: "Veg",
            name: "Venilla Milk Shake",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "169",
          },
          {
            emoji: "🥗",
            image: img_StrawberryMilkShake,
            badge: "Veg",
            name: "Strawberry Milk Shake",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "169",
          },
          {
            emoji: "🥗",
            image: img_ChocolateMilkShake,
            badge: "Veg",
            name: "Chocolate Milk Shake",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "179",
          },
          {
            emoji: "🥗",
            image: img_MangoMilkshake,
            badge: "Veg",
            name: "Manago Milk Shake",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "189",
          },
          {
            emoji: "🥗",
            image: img_BlackCurrentMilkShake,
            badge: "Veg",
            name: "Black Current Milk Shake",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "189",
          },
          {
            emoji: "🥗",
            image: img_ButterscotchMilkShake,
            badge: "Veg",
            name: "Butterscotch Milk Shake",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "189",
          },
          {
            emoji: "🥗",
            image: img_WaterMelonJuice,
            badge: "Veg",
            name: "Water Melon Juice",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "109",
          },
          {
            emoji: "🥗",
            image: img_OrangeJuice,
            badge: "Veg",
            name: "Orange Juice",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "119",
          },
          {
            emoji: "🥗",
            image: img_SathukudiJuice,
            badge: "Veg",
            name: "Sathukudi Juice",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "119",
          },
          {
            emoji: "🥗",
            image: img_PinappleJuice,
            badge: "Veg",
            name: "Pinapple Juice",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "139",
          },
          {
            emoji: "🥗",
            image: img_AppleJuice,
            badge: "Veg",
            name: "Apple Juice",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "139",
          },
          {
            emoji: "🥗",
            image: img_MuskmelonJuice,
            badge: "Veg",
            name: "Muskmelon Juice",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "129",
          },
          {
            emoji: "🥗",
            image: img_PomogranateJuice,
            badge: "Veg",
            name: "Pomogranate Juice",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "139",
          },
          {
            emoji: "🥗",
            image: img_TwinBerry,
            badge: "Veg",
            name: "Twin Berry",
            desc: "Beverages[CB]",
            tag: "Veg | Halal",
            price: "179",
          },
        ],
        "delightful-dessert": [
          {
            emoji: "🥗",
            image: img_GulabJamun2pcs,
            badge: "Veg",
            name: "Gulab Jamun(2pcs)",
            desc: "Delightful Dessert[CB]",
            tag: "Veg | Halal",
            price: "69",
          },
          {
            emoji: "🥗",
            image: img_BreadHalwa100gms,
            badge: "Veg",
            name: "Bread Halwa 100 gms",
            desc: "Delightful Dessert[CB]",
            tag: "Veg | Halal",
            price: "69",
          },
          {
            emoji: "🥗",
            image: img_Brownie60gms,
            badge: "Veg",
            name: "Brownie 60 gms",
            desc: "Delightful Dessert[CB]",
            tag: "Veg | Halal",
            price: "69",
          },
        ],
        "parotta-combo": [
          {
            emoji: "🍗",
            image: img_2pcsParottaEggKeemaChicken653pcspng,
            badge: "Non-Veg",
            name: "2pcs Parotta + Egg Masala + Fish 65",
            desc: "Parotta Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "279",
          },
          {
            emoji: "🍗",
            image: img_2pcsParottaEggKeemaChicken653pcspng,
            badge: "Non-Veg",
            name: "2pcs Parotta + Egg Keema + Chicken-65 (3pcs)",
            desc: "Parotta Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "279",
          },
          {
            emoji: "🥗",
            image: img_2pcsParottaVegChettinaduVegSukkapng,
            badge: "Veg",
            name: "2pcs Parotta + Veg Chettinadu + Veg Sukka",
            desc: "Parotta Combo[CB]",
            tag: "Veg | Halal",
            price: "289",
          },
          {
            emoji: "🍗",
            image: img_2pcsParottaChickenChettinadu,
            badge: "Non-Veg",
            name: "2pcs Parotta + Chicken Chettinadu",
            desc: "Parotta Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "219",
          },
        ],
        "chapati-combo": [
          {
            emoji: "🍗",
            image: img_2pcsChappatiEggMasalaChicken653pcspng,
            badge: "Non-Veg",
            name: "2pcs Chappati + Egg Masala + Chicken-65 (3pcs)",
            desc: "Chapati Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "279",
          },
          {
            emoji: "🍗",
            image: img_2pcsChappatiChickenMasalaTandooriLeg1pcspng,
            badge: "Non-Veg",
            name: "2pcs Chappati + Chicken Masala + Tandoori Leg-1pcs",
            desc: "Chapati Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "319",
          },
          {
            emoji: "🍗",
            image: img_2pcsChappatiEggKeemaMasala2png,
            badge: "Non-Veg",
            name: "2pcs Chappati + Egg Keema Masala",
            desc: "Chapati Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "209",
          },
          {
            emoji: "🥗",
            image: img_2pcsChappatiVegSukkaPlainChettinadGravy,
            badge: "Veg",
            name: "2pcs Chappati + Veg Sukka + Plain Chettinad Gravy",
            desc: "Chapati Combo[CB]",
            tag: "Veg | Halal",
            price: "269",
          },
        ],
        "veg-fried-rice-combo": [
          {
            emoji: "🥗",
            image: img_VegFriedRiceVegSukka,
            badge: "Veg",
            name: "Veg Fried Rice + Veg Sukka",
            desc: "Veg Fried Rice Combo[CB]",
            tag: "Veg | Halal",
            price: "259",
          },
          {
            emoji: "🥗",
            image: img_VegFriedRiceVegLollypop3Pcs,
            badge: "Veg",
            name: "Veg Fried Rice + Veg Lollypop (3 Pcs)",
            desc: "Veg Fried Rice Combo[CB]",
            tag: "Veg | Halal",
            price: "249",
          },
        ],
        "dosa-combo": [
          {
            emoji: "🥗",
            image: img_2pcsDosaKadaiVegVegLollypop3pcs,
            badge: "Veg",
            name: "2pcs Dosa + Kadai Veg + Veg Lollypop (3pcs)",
            desc: "Dosa Combo[CB]",
            tag: "Veg | Halal",
            price: "279",
          },
          {
            emoji: "🍗",
            image: img_2pcsDosaEggMasalapng,
            badge: "Non-Veg",
            name: "2pcs Dosa + Egg Masala",
            desc: "Dosa Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "219",
          },
          {
            emoji: "🍗",
            image: img_2pcsEggDosaChetinaduPlainGravypng,
            badge: "Non-Veg",
            name: "2pcs Egg Dosa + Chetinadu Plain Gravy",
            desc: "Dosa Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "249",
          },
          {
            emoji: "🍗",
            image: img_2pcsDosaChickenCurrypng,
            badge: "Non-Veg",
            name: "2pcs Dosa + Chicken Curry",
            desc: "Dosa Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "239",
          },
        ],
        "tandoori-chicken-combo": [
          {
            emoji: "🍗",
            image: img_TandooriChicken1pcsTandooriRoti2pcsEggMasalapng,
            badge: "Non-Veg",
            name: "Tandoori Chicken-1pcs + Tandoori Roti-2pcs + Egg Masala",
            desc: "Tandoori Chicken Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "299",
          },
          {
            emoji: "🍗",
            image: img_TandooriChicken1pcsPulk4pcsMixVegCurrypng,
            badge: "Non-Veg",
            name: "Tandoori Chicken-1pcs + Pulk-4pcs + Mix Veg Curry",
            desc: "Tandoori Chicken Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "299",
          },
          {
            emoji: "🍗",
            image: img_TandooriChicken1pcsEggFriedRice,
            badge: "Non-Veg",
            name: "Tandoori Chicken-1pcs + Egg Fried Rice",
            desc: "Tandoori Chicken Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "359",
          },
        ],
        "chicken-kebab-combo": [
          {
            emoji: "🍗",
            image: img_3pcsChickenKebabDhalRicepng,
            badge: "Non-Veg",
            name: "3pcs Chicken Kebab + Dhal Rice",
            desc: "Chicken Kebab Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "269",
          },
          {
            emoji: "🍗",
            image: img_3pcsChickenKebabCurdRicepng,
            badge: "Non-Veg",
            name: "3pcs Chicken Kebab + Curd Rice",
            desc: "Chicken Kebab Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "249",
          },
          {
            emoji: "🍗",
            image: img_3pcsChickenKebabEggFriedRicepng,
            badge: "Non-Veg",
            name: "3pcs Chicken Kebab + Egg Fried Rice",
            desc: "Chicken Kebab Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "259",
          },
        ],
        "barbequeen-chicken-combo": [
          {
            emoji: "🍗",
            image: img_AlFaham1pcsPulka4pcsEggChettinadupng,
            badge: "Non-Veg",
            name: "Al-Faham-1pcs + Pulka-4pcs + Egg Chettinadu",
            desc: "Barbequeen Chicken Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "299",
          },
          {
            emoji: "🍗",
            image: img_AlFahamHalfPulka2pcsCucumberSaladpng,
            badge: "Non-Veg",
            name: "Al-Faham Half + Pulka-2pcs + Cucumber Salad",
            desc: "Barbequeen Chicken Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "349",
          },
          {
            emoji: "🍗",
            image: img_AlFaham1pcsDhalRicepng,
            badge: "Non-Veg",
            name: "Al-Faham-1pcs + Dhal Rice",
            desc: "Barbequeen Chicken Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "289",
          },
        ],
        "sea-food-combo": [
          {
            emoji: "🍗",
            image: img_CrispyFriedFishEggFriedRice,
            badge: "Non-Veg",
            name: "Crispy Fried Fish + Egg Fried Rice",
            desc: "Sea Food Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "259",
          },
          {
            emoji: "🍗",
            image: img_ButterflyPrawns4pcsEggFriedRice,
            badge: "Non-Veg",
            name: "Butterfly Prawns-4pcs + Egg Fried Rice",
            desc: "Sea Food Combo[CB]",
            tag: "Non-Veg | Halal",
            price: "329",
          },
        ],
      },
    },

    whyUs: {
      eyebrow: "Why Combo Box",
      title: "THE COMBO BOX EDGE",
      cards: [
        {
          icon: "halal",
          title: "100% Halal Certified",
          desc: "Every ingredient, every dish — strictly Halal certified. We take our commitment to Halal seriously so you can eat with complete confidence.",
        },
        {
          icon: "📦",
          title: "Packed Right",
          desc: "Every combo is portioned, packaged, and sealed to stay fresh and arrive hot at your doorstep.",
        },
        {
          icon: "💰",
          title: "Value for Money",
          desc: "Best non-veg combo value in Tamil Nadu — guaranteed quality.",
        },
        {
          icon: "🌶️",
          title: "Tamil Nadu Spice Level",
          desc: "Recipes crafted for Tamil Nadu's palate — bold, spiced, and authentic to the region's food culture.",
        },
        {
          icon: "⚡",
          title: "Fast Delivery",
          desc: "Quick kitchen turnaround and delivery partnership with Zomato & Swiggy for fast, reliable service.",
        },
        {
          icon: "🥩",
          title: "Fresh Meat Daily",
          desc: "Fresh Halal non-veg ingredients sourced daily. No frozen stocks — cooked fresh every single day.",
        },
      ],
    },

    orderOnline: {
      eyebrow: "Order Now",
      title: "ORDER ONLINE",
      subtitle: "Get Combo Box delivered hot and fresh to your doorstep",
      platforms: [
        {
          icon: "🍽️",
          name: "Zomato",
          tag: "Order Online",
          href: "https://www.zomato.com/salem/combo-box-alagapuram-pudur/order",
        },
        {
          icon: "🛵",
          name: "Swiggy",
          tag: "Fast Delivery",
          href: "https://www.swiggy.com",
        },
        {
          icon: "📞",
          name: "Call Us",
          tag: "Direct Order",
          href: "tel:+919XXXXXXXXX",
        },
      ],
    },

    cta: {
      title: "HUNGRY?\nORDER NOW.",
      subtitle:
        "Get your favourite Combo Box delivered in minutes. Fresh, hot, and packed with flavour. 100% Halal.",
      button: {
        label: "Order on Zomato 🍴",
        href: "https://www.zomato.com/salem/combo-box-alagapuram-pudur/order",
      },
      address: "📍 Alagapuram Pudur, Salem, Tamil Nadu | combobox.in",
    },

    blog: {
      eyebrow: "From Our Kitchen",
      title: "LATEST BLOGS",
      posts: [
        {
          id: 1,
          slug: "seeraga-samba-biryani-special",
          title: "What Makes Seeraga Samba Biryani So Special?",
          coverEmoji: "🍛",
          coverImage: blogCover1,
          excerpt:
            "Seeraga Samba rice is the secret behind Tamil Nadu's legendary biryani. Smaller, more aromatic and more absorbent than basmati, this short-grain rice soaks up every masala it meets. At Combo Box, we source the finest Seeraga Samba to bring you an authentic flavour that no other rice can replicate.",
          date: "15 APRIL 2025",
          author: "Combo Box Kitchen",
          tag: "Food Culture",
          readTime: "4 min read",
          body: [
            {
              type: "intro",
              text: "Ask any Tamil Nadu food lover what makes a great biryani and they will tell you one word: Seeraga Samba. This short-grain heritage rice has been at the heart of South Indian biryani culture for centuries — and at Combo Box, it is the soul of every biryani we serve.",
            },
            {
              type: "heading",
              text: "What Is Seeraga Samba Rice?",
            },
            {
              type: "paragraph",
              text: "Seeraga Samba (also spelled Seeraga Samba) is a small, thin-grained variety of rice native to Tamil Nadu. The name itself means 'cumin rice' in Tamil — named for its resemblance to cumin seeds. Unlike basmati, which is long and separate, Seeraga Samba is short, plump, and incredibly aromatic on its own.",
            },
            {
              type: "paragraph",
              text: "What makes it truly special is its ability to absorb masalas deeply. When cooked with whole spices, ginger-garlic paste, caramelised onions and your choice of meat, Seeraga Samba transforms every grain into a flavour-packed bite. There is no bland forkful — every spoonful carries the full weight of the spice.",
            },
            {
              type: "heading",
              text: "Why We Choose Seeraga Samba at Combo Box",
            },
            {
              type: "paragraph",
              text: "We made the deliberate choice to build our entire biryani menu around Seeraga Samba — not basmati — because we believe in authentic Tamil Nadu flavour. Our customers from Salem, Coimbatore and Erode grew up with this rice. It tastes like home.",
            },
            {
              type: "bullets",
              items: [
                "Richer aroma than long-grain varieties",
                "Superior spice absorption — every grain carries flavour",
                "Naturally non-sticky; stays fluffy even after delivery",
                "Culturally rooted in Tamil Nadu's culinary identity",
                "Perfect with salna, raita, or just by itself",
              ],
            },
            {
              type: "heading",
              text: "Our Seeraga Samba Biryani Varieties",
            },
            {
              type: "paragraph",
              text: "At Combo Box, we offer Classic Seeraga Samba Chicken Biryani, Special Seeraga Samba Mutton Biryani, Seeraga Samba Prawn Biryani, and Seeraga Samba Egg Biryani — each prepared fresh daily with 100% Halal certified meat and the finest spices. Available for delivery on Zomato and Swiggy across Tamil Nadu.",
            },
            {
              type: "cta",
              text: "Order your Seeraga Samba Biryani now",
              href: "https://www.zomato.com/salem/combo-box-alagapuram-pudur/order",
            },
          ],
        },
        {
          id: 2,
          slug: "why-halal-matters",
          title: "Why Halal Matters — Our Promise to You",
          coverEmoji: "halal",
          coverImage: blogCover2,
          excerpt:
            "At Combo Box, Halal isn't just a label — it's a commitment we live every single day. From sourcing fresh Halal-certified meat to maintaining rigorous kitchen standards, we ensure every bite you take is prepared with integrity and care.",
          date: "22 APRIL 2025",
          author: "Combo Box Team",
          tag: "Our Values",
          readTime: "5 min read",
          body: [
            {
              type: "intro",
              text: "When you choose Combo Box, you are choosing more than a meal. You are choosing a brand that takes food integrity seriously. Our 100% Halal certification is not a marketing claim — it is a daily operational standard that governs everything we do, from procurement to plating.",
            },
            {
              type: "heading",
              text: "What Does Halal Actually Mean?",
            },
            {
              type: "paragraph",
              text: "Halal is an Arabic word meaning 'permissible'. In the context of food, it refers to a comprehensive set of guidelines that govern how animals are raised, slaughtered, processed and prepared. Halal meat must come from healthy animals, slaughtered by a Muslim in the name of Allah, with the blood fully drained. No pork, no alcohol, no cross-contamination.",
            },
            {
              type: "paragraph",
              text: "Beyond the ritual, Halal also implies cleanliness, humane treatment, and ethical sourcing. It is a standard that many non-Muslim consumers actively choose because it also aligns with quality and hygiene benchmarks.",
            },
            {
              type: "heading",
              text: "Our Halal Commitment at Every Step",
            },
            {
              type: "bullets",
              items: [
                "All chicken, mutton, prawn and fish sourced from Halal-certified suppliers",
                "Daily fresh procurement — no frozen, pre-processed stocks",
                "Separate storage and preparation to prevent cross-contamination",
                "Kitchen staff trained in Halal food handling practices",
                "No alcohol-based marinades or non-Halal additives — ever",
              ],
            },
            {
              type: "heading",
              text: "Why It Matters to Our Community in Tamil Nadu",
            },
            {
              type: "paragraph",
              text: "Tamil Nadu is home to a large Muslim community — in Salem, Coimbatore, Erode and beyond — who deserve quality food they can trust completely. But Halal is also increasingly a choice for health-conscious and ethically-minded diners of all backgrounds. At Combo Box, we proudly serve everyone while never compromising on our Halal standard.",
            },
            {
              type: "paragraph",
              text: "You will see the Halal badge on every item on our menu because we believe transparency is part of the promise. When you open your Combo Box, you deserve to know exactly what is inside.",
            },
            {
              type: "cta",
              text: "Order your 100% Halal combo meal today",
              href: "https://www.zomato.com/salem/combo-box-alagapuram-pudur/order",
            },
          ],
        },
        {
          id: 3,
          slug: "combo-box-expanding-salem-coimbatore-erode",
          title: "Combo Box is Expanding — Salem, Coimbatore & Erode",
          coverEmoji: "📍",
          coverImage: blogCover3,
          excerpt:
            "What started as a single outlet at Alagapuram Pudur, Salem is now growing into a Tamil Nadu-wide movement. We are excited to announce our expansion to Coimbatore and Erode, bringing the same great Seeraga Samba Biryani and 100% Halal combo meals closer to you.",
          date: "28 APRIL 2025",
          author: "Combo Box Team",
          tag: "Expansion News",
          readTime: "3 min read",
          body: [
            {
              type: "intro",
              text: "When we opened our first outlet at Alagapuram Pudur, Salem, we had a simple vision: to serve Tamil Nadu's best Halal non-veg combo meals at honest prices. Salem believed in us, and the response has been overwhelming. Today, we are proud to announce the next chapter.",
            },
            {
              type: "heading",
              text: "Our Story So Far — Salem",
            },
            {
              type: "paragraph",
              text: "Our Salem flagship at Alagapuram Pudur has been serving the community since day one — building a loyal base of students, families and office-goers who come back for our Seeraga Samba Biryani again and again. A 4.0-star Zomato rating and thousands of happy customers later, it was time to grow.",
            },
            {
              type: "heading",
              text: "Coming Soon — Coimbatore",
            },
            {
              type: "paragraph",
              text: "Coimbatore — the Manchester of South India — is our next destination. Known for its vibrant food culture and large working population, Coimbatore is a perfect fit for the Combo Box experience. Expect the same Seeraga Samba Biryani, the same 100% Halal promise, and the same great value meals .",
            },
            {
              type: "heading",
              text: "Coming Soon — Erode",
            },
            {
              type: "paragraph",
              text: "Erode, with its rich trading heritage and food-loving population, is the third city in our expansion roadmap. We are working to bring Combo Box to Erode residents who have been asking for us. Stay tuned for the exact launch date.",
            },
            {
              type: "bullets",
              items: [
                "Salem (Flagship) — Alagapuram Pudur — Open Now",
                "Coimbatore — Coming Soon",
                "Erode — Coming Soon",
                "All locations serve 100% Halal certified meals",
                "All locations available on Zomato & Swiggy for delivery",
              ],
            },
            {
              type: "paragraph",
              text: "Follow us on social media or visit combobox.in to be the first to know when we open in your city. The Combo Box family is growing — and we can't wait to serve you.",
            },
            {
              type: "cta",
              text: "Order from Salem now on Zomato",
              href: "https://www.zomato.com/salem/combo-box-alagapuram-pudur/order",
            },
          ],
        },
      ],
    },
  },

  pages: {
    homePage: {
      aboutSection: {
        eyebrow: "About Us",
        title: "WHAT IS COMBO BOX?",
        heading: "Tamil Nadu's Favourite\nHalal Non-Veg\nCombo Destination",
        paragraphs: [
          "Combo Box is a 100% Halal certified quick-service non-veg restaurant brand under combobox — Tamil Nadu's growing food group. We built Combo Box around one simple idea: great Halal non-veg food, packed into one complete box, at an honest price.",
          "Our flagship outlet is located at Alagapuram Pudur, Salem — and we are doing services in Coimbatore and Erode — available for delivery across these cities via Zomato & Swiggy. Combo Box serves office workers, students, and families who want a quick, satisfying, Halal non-veg meal without compromise.",
          "Our branches: Salem (Flagship), Coimbatore, and Erode — bringing the best of Tamil Nadu's food culture to your neighbourhood.",
        ],
        highlights: [
          "100% Halal Certified — every dish, every day",
          "Non-veg only — chicken, mutton, prawn, fish, egg",
          "Authentic Seeraga Samba Biryani — Tamil Nadu's finest",
          "Complete combo meals",
          "Available on Zomato & Swiggy for delivery",
          "Branches in Salem, Coimbatore & Erode",
          "A combobox brand — combobox.in",
        ],
        visualTagline: '"One Box.\nEvery Flavour.\nThe Royal Taste."',
        visualTag: "A combobox Brand",
        branches: [
          {
            city: "Salem",
            detail: "Alagapuram Pudur (Flagship)",
            status: "open",
          },
          { city: "Coimbatore", detail: "Open Now", status: "open" },
          { city: "Erode", detail: "Open Now", status: "open" },
        ],
      },
    },
  },
};
